import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'

import pic11 from '../assets/images/pic11.jpg'

const AboutMe = (props) => (
    <Layout>
        <Helmet>
            <title>Abhishek Mallepalli</title>
            <meta name="About Me" content="About Me" />
        </Helmet>

        <div id="main" className="alt">
            <section id="one">
                <div className="inner">
                    <header className="major">
                        <h1>About Me</h1>
                    </header>
                    <span className="image main"><img src={pic11} alt="" /></span>
                    <p> I am a Los Angeles based software engineer that specializes in Javascript.
                                While I am most proficient with MERN stack, I have experience with many web technologies. For more information regarding my prior work, my resume is linked in the header. My interest is creating performant and scalable systems that meet and exceed specifications. I also have deployment experience with several AWS resources including S3, EC2, RDS, and Route 53. I have CI/CD experience. I studied computer science at CSUN and I'm a graduate of Hack Reactor. Feel free to reach out to me with opportunities or just to say 'hi.' You can reach me at <a href="mailto:mallepalliabhishek@gmail.com">mallepalliabhishek@gmail.com</a>
                                </p>
                </div>
            </section>
        </div>

    </Layout>
)

export default AboutMe